<template>
  <div class="departure">
      <table style="width:100%;">
          <thead>
            <th style="width:20%">Number</th>
            <th style="width:auto">Direction</th>
            <th style="width:20%;" v-if="showPlatform">Platform</th>
            <th style="width:10%;">Time</th>
          </thead>
          <tbody>
              <tr v-for="item in board" :key="item">
                  <td>
                      {{item.number}}
                  </td>
                  <td>
                      {{item.to}}
                  </td>
                  <td v-if="showPlatform">
                      {{ item.stop.platform }}
                  </td>
                  <td>
                      {{ convertTime(item.stop.departureTimestamp) }}
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
</template>

<script>
import axios from 'axios';
import DateFormatter from '../../lib/dateformatter';

export default {
    props: {
        location: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            board: [],
            showPlatform: false
        }
    },
    mounted() {
        this.getLocationDepartures(this.location);
        setInterval(() => this.getLocationDepartures(this.location), 60000);
    },
    methods: {
        getLocationDepartures(station) {
            var u_station = encodeURIComponent(station);
            axios.get("https://transport.opendata.ch/v1/stationboard?station="+u_station+"&limit=5").then(function(response){
                if(response.status === 200) {
                    this.board = response.data.stationboard;
                    this.board.forEach(function(item) {
                        if(item.stop.platform !== null) {
                            this.showPlatform = true;
                        }
                    }.bind(this));
                }
                this.$emit("loaded");
            }.bind(this));
        },
        convertTime(timestamp) {
            return DateFormatter.fromTimeStampToTime(timestamp);
        }
    }
}
</script>

<style>
th, td {
    text-align: left;
}
</style>